// Creates a local object URL for previewing a file before upload
export function createPreviewUrl(file) {
  return URL.createObjectURL(file);
}

// Revoke a previously created object URL to free memory
export function revokePreviewUrl(url) {
  if (url && url.startsWith('blob:')) {
    URL.revokeObjectURL(url);
  }
}
